<template>
  <center>
    <v-card
      :height="dynamicHeight"
      outlined
      class="mb-1"
      style="overflow-y: scroll; overflow-x: hidden"
      @scroll="onScroll"
      ref="pdfContainer"
    >
      <v-overlay :value="isLoading" :opacity="0.8" absolute style="z-index: 15">
        <div style="text-align: center">
          <div
            style="
              width: 100px;
              height: 100px;
              border-radius: 50%;
              margin: auto;
              padding-top: 13px;
              background-color: #000000;
            "
          >
            <v-progress-circular indeterminate size="72"></v-progress-circular>
          </div>
        </div>
      </v-overlay>
      <v-card-text>
        <pdf
          v-for="i in totalPages"
          :key="i"
          :src="fileLoader"
          :page="i"
          @loaded="isLoading = false"
        ></pdf>
      </v-card-text>
    </v-card>
  </center>
</template>

<script>
import pdf from "vue-pdf";

export default {
  components: {
    pdf,
  },

  props: {
    fileId: {
      type: String,
      required: true,
    },
    height: {
      type: String,
      default: "500px",
    },
    heightAutoCalculate: {
      type: Boolean,
    },
    heightAutoResize: {
      type: Boolean,
    },
    heightOffset: {
      type: Number,
      default: 0,
    },
  },

  data: function () {
    return {
      isLoading: true,
      dynamicHeight: this.height,
      totalPages: null,
      fileLoader: pdf.createLoadingTask({
        url: `${window.amplifyRuntimeConfig.get(
          "VUE_APP_API_BASE_URL"
        )}/public/files/${this.fileId}/view`,
        isEvalSupported: false,
      }),
      hasScrolledToBottom: false,
    };
  },

  methods: {
    recalculateHeight() {
      if (!this.heightAutoResize) {
        return this.dynamicHeight;
      }
      this.calculateHeight();
    },

    calculateHeight() {
      var windowHeight = window.innerHeight;
      this.dynamicHeight = windowHeight - this.heightOffset + "px";
    },

    onScroll() {
      if (this.hasScrolledToBottom) {
        return;
      }
      const pdfContainer = this.$refs.pdfContainer.$el;

      const scrollPercentage =
        (pdfContainer.scrollTop + pdfContainer.clientHeight) /
        pdfContainer.scrollHeight;

      // Consider it "scrolled to bottom" if we're at 99% or more having issues when off by 1 or 2 px
      if (scrollPercentage >= 0.99) {
        this.hasScrolledToBottom = true;
        this.$emit("scroll-complete");
      }
    },

    observeLastPageResize() {
      this.observer = new ResizeObserver(([entry]) => {
        const canvas = entry.target;
        // default height of each canvas before being resized for the content of the agreement page
        if (canvas.height !== 150) {
          this.$nextTick(() => {
            this.onScroll();
            this.observer.disconnect();
            this.observer = null;
          });
        }
      });

      // Find the last page element
      const canvases = this.$el.querySelectorAll("canvas");
      if (canvases.length > 0) {
        const lastPage = canvases[canvases.length - 1];
        this.observer.observe(lastPage);
      }
    },
  },
  watch: {
    heightOffset() {
      this.recalculateHeight();
    },
    isLoading(loadingState) {
      if (!loadingState) {
        this.observeLastPageResize();
      }
    },
  },

  mounted: function () {
    this.fileLoader.promise.then((pdf) => {
      this.totalPages = pdf.numPages;
    });

    if (this.heightAutoCalculate) {
      this.calculateHeight();
    }

    window.addEventListener("resize", () => this.recalculateHeight());
  },

  beforeDestroy() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  },
};
</script>

<style lang="scss"></style>
